import UploadEpics from './upload.epic';
import JobsEpics from './jobs.epic';

const JobEpics = [
  ...UploadEpics,
  ...JobsEpics
];

export default JobEpics;